import { render, staticRenderFns } from "./soporte.vue?vue&type=template&id=e782383a&scoped=true&"
import script from "./soporte.vue?vue&type=script&lang=js&"
export * from "./soporte.vue?vue&type=script&lang=js&"
import style0 from "./soporte.vue?vue&type=style&index=0&id=e782383a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e782383a",
  null
  
)

export default component.exports